import React from "react";
import { Container, TextField, Button } from "@mui/material";
import logo from "./LogoG.jpg";
import GoogleIcon from "@mui/icons-material/Google";
import { auth, googleProvider } from "../config/firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const signIn = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (err) {
      console.error(err);
      setSnackbarMessage(err.message);
      setOpenSnackbar(true);
    }
  };

  /*const signInWithGoogle = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      navigate("/");
    } catch (err) {
      console.error(err);
      setSnackbarMessage(err.message);
      setOpenSnackbar(true);
    }
  };*/

  const StyledButton = styled(Button)({
    fontWeight: "bold",
    backgroundColor: "#000",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#ff0000",
    },
  });

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "100%",
            padding: "15px",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ alignSelf: "center", width: "200px", height: "auto" }}
          />
          <TextField
            label="Email"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          <StyledButton variant="contained" color="primary" onClick={signIn}>
            Sign in
          </StyledButton>
          {/*<StyledButton
            variant="contained"
            color="primary"
            onClick={signInWithGoogle}
            startIcon={<GoogleIcon />}
          >
            Sign in with Google
          </StyledButton>*/}
        </div>
      </Container>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
